import React, { useEffect, useRef } from "react";
import { Skeleton, useMediaQuery } from "@mui/material";
import AirDatepicker from "air-datepicker";
import "air-datepicker/air-datepicker.css";
import localeEn from "air-datepicker/locale/en";
import localeEs from "air-datepicker/locale/es";
import { useTranslation } from "react-i18next";
import { CustomDiv, HorizontalCenterDiv } from "../divs";
import "@/assets/styles/datePicker.css";
import { AlmostBoldText } from "../texts";
import GoogleTranslationComponent from "@/components/googleTranslate/GoogleTranslationComponent";

//@ts-ignore
function AirDatePickerWithNoBorders(props) {
  const $input = useRef();
  const dp = useRef();
  const { t, i18n } = useTranslation();

  // Start init
  useEffect(() => {
    // Save instance for the further update
    //@ts-ignore
    dp.current = new AirDatepicker($input.current, {
      ...props,
      range: false,
      fixedHeight: true,
      locale: i18n.language == "en" ? localeEn : localeEs,
      inline: true,
      startDate: props.startDate,
      onSelect: function (data) {
        if (props.changeValue) {
          if (data.date) {
            props.changeValue(data.date);
          }
        }
      },
      onChangeViewDate({ month, year }) {
        if (props.changeMonth) {
          props.changeMonth(year, month);
        }
      },
      onRenderCell: function (options: any) {
        if (props.availableDates) {
          const year = new Date(options.date).getFullYear().toString();
          let month = (new Date(options.date).getMonth() + 1).toString();
          let day = new Date(options.date).getDate().toString();
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          if (options.cellType === "day") {
            const parseDate = year + "-" + month + "-" + day;
            if (props.availableDates.includes(parseDate)) {
              return {
                disabled: false,
                classes: "enabled-class",
                attrs: {
                  title: "Cell is enabled",
                },
              };
            } else {
              return {
                disabled: true,
                classes: "disabled-class",
                attrs: {
                  title: "Cell is disabled",
                },
              };
            }
          }
        }
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); //need the missing dependency

  useEffect(() => {
    // Update if props are changed
    //@ts-ignore
    dp.current.update({ ...props });
    showCalendar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);
  //@ts-ignore

  const showCalendar = () => {
    if (dp.current) {
      //check if maxDate is today
      if (
        //@ts-ignore
        new Date(dp.current.maxDate).getFullYear() ===
          new Date().getFullYear() &&
        //@ts-ignore
        new Date(dp.current.maxDate).getMonth() === new Date().getMonth() &&
        //@ts-ignore
        new Date(dp.current.maxDate).getDay() === new Date().getDay()
      ) {
        /* empty */
      } else {
        props.setShowVisibility(true);
      }
    }
  };

  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <>
      <CustomDiv
        style={{ display: props.showVisibility ? "block" : "none" }}
        className="auto-mobile-width"
        width={props.width ?? "482px"}
        height={props.height ?? "246px"}
      >
        <HorizontalCenterDiv
          className="calendar-reservation-title"
          style={{
            width: props.width ?? "482px",
          }}
        >
          <AlmostBoldText fontSize="18px">
            {t("reservation_schedule.subtitled")}
          </AlmostBoldText>
        </HorizontalCenterDiv>
        <div
          //@ts-ignore
          ref={$input}
        />
      </CustomDiv>
      <Skeleton
        className="auto-mobile-width"
        style={{
          display: props.showVisibility ? "none" : "block",
          height: props.height ?? "246px",
          width: isMobile ? "340px" : (props.width ?? "482px"),
          borderRadius: "16px",
        }}
      ></Skeleton>
      <HorizontalCenterDiv
        width={isMobile ? "340px" : (props.width ?? "482px")}
        style={{
          position: "absolute",
          top: "0px",
          display: props.showVisibility ? "none" : "block",
        }}
      >
        <AlmostBoldText>
          <GoogleTranslationComponent text="Buscando fechas disponibles" />
        </AlmostBoldText>
      </HorizontalCenterDiv>
    </>
  );
}

export default AirDatePickerWithNoBorders;
